import VueRouter, { RouteConfig } from 'vue-router';
import store from '@/store/index';

import Page from '@/pages/Page.vue';
import EventListPage from '@/pages/EventListPage.vue';
import WeatherPage from '@/pages/WeatherPage.vue';

// ścieżki do MapOverlay z głównego menu
const routes: Array<RouteConfig> = [
  { path: '/', name: 'Map', component: Page },
  { path: '/events', name: 'Events', component: EventListPage },
  { path: '/weather', name: 'Weather', component: WeatherPage },
  { path: '/timetable', name: 'Timetable', component: Page },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeEach((to, from, next) => {
  store.commit('setCurrentRoute', to);
  next();
});

export default router;
